import { requests } from '../apiAgent';

export const AssingAvailabilityAPI = {
    assingAvailability: (body: { WorkshiftSchedulingIds: number[] }) => {
        return requests
            .put(
                '/jerusalem/api/v2.0.0/workshift-schedulings/create-availability-workshift-scheduling',
                body
            )
            .then((response) => console.log(response));
    },
    removeAvailability: (body: { WorkshiftSchedulingIds: number[] }) => {
        return requests
            .put(
                '/jerusalem/api/v2.0.0/workshift-schedulings/delete-availability-workshift-scheduling',
                body
            )
            .then((response) => console.log(response));
    },
};
